import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCNCdewlOZfshT8JTgYTejYcts0CNG8H3g",
  authDomain: "chat2-f3cef.firebaseapp.com",
  projectId: "chat2-f3cef",
  storageBucket: "chat2-f3cef.appspot.com",
  messagingSenderId: "288475297896",
  appId: "1:288475297896:web:0695481f9fb0542fefa3dd",
  measurementId: "G-9SHCDC4N1Q"
};

// Initialize Firebase
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();